export default {
  SET_ACTION_TYPES(state, action_types) {
    state.action_types = action_types
  },
  REMOVE_ACTION_TYPES(state, itemId) {
      const roleIndex = state.action_types.datas.findIndex((u) => u.id == itemId)
      state.action_types.datas.splice(roleIndex, 1)
  },
  SELECTED_ACTION_TYPES(state,data){
    state.action_types.datas = []
    state.action_types.total = 1;
    state.action_types.per_page = 1;
    state.action_types.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.action_type = data
  },
  ADD_ITEM(state,data){
    state.action_type = data
  },
}
